module.exports = __webpack_public_path__ + "static/media/default-mobile.b224cc73.jpg";